<template>
  <div>
    <div class="container_top_img">
      <img src="../../assets/img/new/unionTopBanner.png" alt="logo">
    </div>
    <div class="my_container">
      <!-- 联盟生态顶部导航 -->
      <div class="glag_all union_nav_top_list">
        <div class="union_nav_top_ul industry_alliance_box">
          <div class="union_nav_top_head">
            行业联盟
          </div>
          <div v-for="(item, index) in industryNavList"
          :key="item.id"
          :class="item.id === parseInt(unionId) ? 'union_nav_top_item active' : 'union_nav_top_item'"
          @click="navJump(item.id, index, 'industry')">
            <i></i>
            <dl>
              <dt>{{item.union_name}}</dt>
              <dd>{{item.union_en_name}}</dd>
            </dl>
          </div>
        </div>
        <div class="union_nav_top_ul professional_alliance_box">
          <div class="union_nav_top_head">
            专业联盟
          </div>
          <div v-for="(item, index) in majorNavList"
          :key="item.id"
          :class="item.id === parseInt(unionId) ? 'union_nav_top_item active' : 'union_nav_top_item'"
          @click="navJump(item.id, index, 'major')">
            <i></i>
            <dl>
              <dt>{{item.union_name}}</dt>
              <dd>{{item.union_en_name}}</dd>
            </dl>
          </div>
        </div>
      </div>
      <!-- 联盟简介 -->
      <div class="glag_all">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>联盟简介</span>
            <router-link class="rt" :to="{ path: '/unionIntroduce', query: {id: unionId, type: 'introduce'} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
        </div>
        <div class="glag_calss_introduce">
          <div class="glag_calss_introduce_left">
            <img src="../../assets/img/new/glagCalssIntroduce.jpg" alt="联盟封面">
          </div>
          <div class="glag_calss_introduce_right">
            <dl>
              <dt>{{unionContent.union_name}}</dt>
              <dd>一院多盟一平台、绿法联盟研究院和行业联盟两大机构</dd>
            </dl>
            <div class="glag_calss_introduce_text">{{unionContent.content}}</div>
          </div>
        </div>
      </div>
      <!-- 组织架构 -->
      <div class="glag_all">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>组织架构</span>
            <router-link class="rt" :to="{ path: '/unionIntroduce', query: {id: unionId, type: 'organizational'} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
        </div>
        <div class="glag_calss_organization">
         <!-- <div class="glag_calss_organization_left">
           <span>组织架构</span>
           <a class="my_icon_list more_icon_circle"></a>
         </div> -->
         <div class="glag_calss_organization_right">
          <dl v-for="n in 9" :key="n.id">
            <dt>
              <img src="../../assets/img/index/002.png" alt="用户头像">
            </dt>
            <dd>
              <p>张三{{n}}</p>
              <b>主席</b>
            </dd>
          </dl>
         </div>
        </div>
      </div>
      <!-- 研讨沙龙 -->
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>研讨沙龙</span>
            <router-link class="rt" :to="{ path: '/discussList', query: { id: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
        </div>
        <div class="union_discuss_box">
          <div class="union_discuss_left lf">
            <div class="union_discuss_img">
              <!-- <img :src="discussInfo.img" alt="" @click="jump(discussInfo.list_id, 10, discussInfo.is_doing)"> -->
              <img :src="discussAct.img" alt="封面">
              <div class="union_discuss_bottom">
                <p class="union_discuss_title">{{discussAct.user_name}}：{{discussAct.title}}</p>
                <div class="union_discuss_other">
                  <span v-if="discussAct.is_doing === 0"><i>{{discussAct.sign_count}}</i> 人报名</span>
                  <span v-if="discussAct.is_doing === 1"><i>{{discussAct.on_count}}</i> 人观看</span>
                   <!-- <el-divider direction="vertical"></el-divider> -->
                  <span v-if="discussAct.is_doing === 2"><i>{{discussAct.comment_count}}</i> 条评论</span>
                </div>
                <div class="union_discuss_button">
                  <button v-if="discussAct.is_doing === 0" class="my_follow_btn">立即报名</button>
                  <button v-if="discussAct.is_doing === 1" class="my_follow_btn">立即观看</button>
                </div>
              </div>
            </div>
          </div>
          <ul class="union_discuss_list lf" slot="pagination">
            <li v-for="item in discussList" :key="item.id" class="union_discuss_item">
              <span v-if="discussAct.is_doing === 0">即将开始</span>
              <span v-if="discussAct.is_doing === 1">进行中</span>
              <span v-if="discussAct.is_doing === 2">已结束</span>
              <a @click= "allJump(item.type, item.list_id, 15, item.is_doing)">
                {{item.title}}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 热搜、推荐、动态 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <span class="comment_btn" :class="navTop === '热搜' ? 'act' : ''" @click="navTopClick('热搜')" style="margin-left: 0;">热搜</span>
            <span class="comment_btn" :class="navTop === '推荐' ? 'act' : ''" @click="navTopClick('推荐')">推荐</span>
            <span class="comment_btn" :class="navTop === '动态' ? 'act' : ''" @click="navTopClick('动态')">动态</span>
            <router-link class="rt" :to="{ path: '/conciseList', query: { nav: 2, type: navTopName, unionId: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
            <el-divider></el-divider>
          </p>
        </div>
        <div class="community_hot_search_box union_hot_search_box" style="margin-top: 0">
          <div v-for="(item, index) in hotList" :key="item.id" class="community_hot_search_item">
            <a data-id="item.list_id">
              <i v-if="index === 0" class="first_label">{{index + 1}}</i>
              <i v-if="index === 1" class="two_label">{{index + 1}}</i>
              <i v-if="index === 2" class="three_label">{{index + 1}}</i>
              <i v-if="index > 2" class="glay_label">{{index + 1}}</i>
              {{item.title}}
            </a>
          </div>
        </div>
      </div>
      <!-- 培训 -->
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>培训</span>
            <router-link class="rt" :to="{ name: 'TrainList', query: { id: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="union_train_box">
          <div v-for="(item, index) in trainList" :key="item.id" class="union_train_item" @click = "trainJump(item.is_buy, index)">
            <div class="union_train_top">
              <p><img :src="item.img" alt="封面"></p>
            </div>
            <div class="union_train_bottom">
              <div class="union_train_title" :class="item.is_buy === 1 && item.price !== '0.00' ? 'union_train_title_left_padding' : ''">
                <i v-if="item.is_buy === 1 && item.price !== '0.00'">已购买</i>
                {{item.title}}
              </div>
              <dl class="union_train_other">
                <dt class="lf" v-if="item.price === '0.00'">免费</dt>
                <dt class="lf" v-else>¥ {{item.price}}</dt>
                <dd class="rt"><span>{{item.read}}</span> 人培训</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <!-- 联盟成员 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <span>联盟成员</span>
            <router-link class="rt" :to="{ name: 'ContactsList' }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="union_contacts_box">
          <div v-for="item in userList" :key="item.id" class="union_contacts_item">
            <div class="union_contacts_left lf">
              <img :src='item.user_avatar'  alt="头像">
            </div>
            <dl class="union_contacts_right lf">
              <dt><span data-id="item.user_id">{{item.user_name}}</span><i>{{item.fans_count}}</i> 人关注</dt>
              <dd>{{item.content}}</dd>
            </dl>
            <button class="greenglga_btn">
              <i class="add">+</i>
              <span>关注</span>
            </button>
          </div>
        </div>
      </div>
      <!-- 项目路演 -->
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span>项目路演</span>
            <router-link class="rt" :to="{ path: '/roadshowList', query: {id: unionId} }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="union_roadshow_box">
          <div class="union_roadshow_right">
            <div v-for="item in roadshowList" :key="item.id" class="union_roadshow_item">
              <div v-if="item.img !== ''" class="union_roadshow_item_left" @click="jump(item.list_id, 16)">
                <div v-if="item.type !== 3" class="video_box_shadow">
                  <i class="my_icon_list player_icon"></i>
                </div>
                <img :src="item.img" alt="封面">
              </div>
              <div :class="item.img === '' ? 'union_roadshow_item_right union_roadshow_item_right_pd_0' : 'union_roadshow_item_right' ">
                <div class="union_roadshow_item_title">
                  <a data-id="item.id" @click="jump(item.list_id, 16)">{{item.title}}</a>
                </div>
                <div class="union_roadshow_item_content">{{item.content}}</div>
                <div class="union_roadshow_item_foot">
                  <div class="union_roadshow_item_user lf">
                    <img :src="item.portrait" alt="头像">
                    <span>{{item.user_name}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{item.add_time}}</span>
                  </div>
                  <div class="union_roadshow_item_other rt">
                    <el-breadcrumb separator="|">
                      <el-breadcrumb-item class="my_icon_box"><a><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.like}}</span></a></el-breadcrumb-item>
                      <el-breadcrumb-item class="my_icon_box r_border"><a><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.comment_count}}</span></a></el-breadcrumb-item>
                      <el-breadcrumb-item></el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 合作 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <span>合作</span>
            <router-link class="rt" :to="{ path: '/cooperationList', query: { id: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="union_cooperation_box">
          <div v-for="item in cooperationList" :key="item.id" class="union_cooperation_item">
            <div class="union_cooperation_info">
              <div class="union_cooperation_img">
                <img :src="item.portrait" alt="头像">
              </div>
              <el-breadcrumb separator="|">
                <el-breadcrumb-item><span class="my_icon_text">{{item.user_name}}</span></el-breadcrumb-item>
                <el-breadcrumb-item><span class="my_icon_text">{{item.add_time}}</span></el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="union_cooperation_title">
              <a @click="jump(item.list_id, 16)">{{item.title}}</a>
            </div>
          </div>
        </div>
      </div>
      <!-- 论坛 -->
      <div class="glag_all">
        <div class="union_forum_box">
          <div class="union_forum_left">
            <p>论坛</p>
            <p @click="listJump(17)">
              <i class="iconfont icon-gengduo"></i>更多
            </p>
          </div>
          <div class="union_forum_right">
            <div v-for="item in forumList" :key="item.id" class="union_forum_item">
              <p class="union_forum_title" @click="jump(item.list_id, 17)">{{item.title}}</p>
              <p class="union_forum_content">{{item.content}}</p>
              <div class="union_forum_info">
                <img :src="item.portrait" alt="头像">
                <span>{{item.user_name}}</span>
                <span>{{item.add_time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 公益、基金会 -->
      <div class="glag_left">
        <div class="title_top_hr">
          <p>
            <i></i>
            <span class="comment_btn" :class="welfareNav === '公益项目' ? 'act' : ''" @click="welfareClick('公益项目')" style="margin-left: 0;">公益项目</span>
            <span class="comment_btn" :class="welfareNav === '基金会' ? 'act' : ''" @click="welfareClick('基金会')">基金会</span>
            <router-link class="rt" v-if="welfareNav === '公益项目'" :to="{ path: '/welfareList', query: { id: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
            <router-link class="rt" v-if="welfareNav === '基金会'" :to="{ path: '/foundationList', query: { id: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
            <el-divider></el-divider>
          </p>
        </div>
        <div class="union_fund_box">
          <div v-for="item in welfareList" :key="item.id" class="union_fund_item">
            <div v-if="item.img !== ''" class="union_fund_left">
              <img :src="item.img" alt="封面">
            </div>
            <div :class="item.img === '' ? 'union_fund_right union_fund_right_pd_0' : 'union_fund_right'">
              <p class="union_fund_title" @click="jump(item.list_id, welfareNavId)">{{item.title}}</p>
              <p class="union_fund_time">{{item.add_time}}</p>
              <p class="union_fund_content">{{item.content}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 俱乐部 -->
      <div class="glag_right">
        <div class="title_top_hr">
          <p>
            <span>俱乐部</span>
            <router-link class="rt" :to="{ path: '/circleList', query: { type: 'union', id: unionId } }" >MORE <u class="iconfont icon-gengduo"></u></router-link>
          </p>
          <el-divider></el-divider>
        </div>
        <div class="union_club_box">
          <div v-for="item in unionList" :key="item.id" class="union_club_item">
            <div class="union_club_item_box">
              <div class="union_club_top">
                <img :src="item.pic" alt="封面">
              </div>
              <div class="union_club_title" @click="circleJump(item.id)">{{item.name}}</div>
              <div class="union_club_bottom">
                <p class="lf">{{item.numbers}}成员</p>
                <div class="rt">
                  <button v-if="item.is_join === 0" class="greenglga_btn">加入</button>
                  <button v-if="item.is_join === 1" class="greenglga_btn greenglga_btn_cancle" disabled="disabled">已加入</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      unionId: '', // 当前联盟id
      industryNavList: [], // 行业联盟导航
      majorNavList: [], // 专业联盟导航
      unionContent: {}, // 联盟简介
      discussAct: {}, // 当前研讨沙龙
      discussList: [], // 研讨沙龙列表
      navTop: '热搜',
      navTopName: 'hot',
      hotList: [], // 热搜列表
      trainList: [], // 培训列表
      userList: [], // 活跃会员
      roadshowList: [], // 项目路演
      cooperationList: [], // 项目合作
      forumList: [], // 论坛列表
      welfareNav: '公益项目', // 栏目默认选中
      welfareList: [], // 公益项目列表
      welfareNavId: 18, // 公益项目/基金会模块id
      unionList: [] // 俱乐部列表
    }
  },
  created () {
    this.unionId = this.$route.query.id
    this.getIndex(this.unionId)
  },
  watch: {
    $route () {
      this.industryNavList = []
      this.majorNavList = []
      this.unionContent = {}
      this.discussAct = {}
      this.discussList = []
      this.navTop = '热搜'
      this.navTopName = 'hot'
      this.hotList = []
      this.trainList = []
      this.userList = []
      this.roadshowList = []
      this.cooperationList = []
      this.forumList = []
      this.welfareList = []
      this.unionList = []
      this.welfareNavId = 18
      this.getIndex(this.unionId)
    }
  },
  methods: {
    // 获取联盟首页信息
    getIndex (id) {
      const vueThat = this
      vueThat.myApi.getUnionIndex({ union_id: id }).then((res) => {
        if (res.data.code === 200) {
          const navList = res.data.data.union_list
          for (let i = 0; i < navList.length; i++) {
            if (navList[i].type === 'industry') {
              vueThat.industryNavList.push(navList[i])
            } else {
              vueThat.majorNavList.push(navList[i])
            }
          }
          vueThat.unionContent = res.data.data.content
          vueThat.discussList = res.data.data.list
          if (vueThat.discussList.length > 0) {
            vueThat.discussAct = res.data.data.list[0]
          }
          vueThat.hotList = res.data.data.hotsearch
          vueThat.userList = res.data.data.users
          vueThat.trainList = res.data.data.train
          vueThat.roadshowList = res.data.data.roadshow
          vueThat.cooperationList = res.data.data.cooperation
          vueThat.forumList = res.data.data.articles
          vueThat.welfareList = res.data.data.public_welfare
          vueThat.unionList = res.data.data.board
        }
      })
    },
    // 导航跳转
    navJump (id, index, type) {
      if (type === 'industry') {
        if (this.industryNavList[index].is_join !== 1) {
          this.$message({
            type: 'error',
            message: '您还未加入该联盟'
          })
        } else {
          this.$router.push({ path: '/union/:id', query: { id: id } })
          this.unionId = id
        }
      } else {
        if (this.majorNavList[index].is_join !== 1) {
          this.$message({
            type: 'error',
            message: '您还未加入该联盟'
          })
        } else {
          this.$router.push({ path: '/union/:id', query: { id: id } })
          this.unionId = id
        }
      }
    },
    // 热搜、推荐、动态
    navTopClick (type) {
      const vueThat = this
      vueThat.navTop = type
      const listPage = {
        union_id: vueThat.unionId,
        type: 2,
        limit: 5,
        page: 1
      }
      switch (type) {
        case '热搜':
          vueThat.navTopName = 'hot'
          vueThat.myApi.hotList(listPage).then((res) => {
            if (res.data.code === 200) {
              vueThat.hotList = res.data.data
              console.log(vueThat.hotList)
            }
          })
          break
        case '推荐':
          vueThat.navTopName = 'recommend'
          vueThat.myApi.recommendList(listPage).then((res) => {
            if (res.data.code === 200) {
              vueThat.hotList = res.data.data
              console.log(vueThat.hotList)
            }
          })
          break
        default:
          vueThat.navTopName = 'dynamic'
          vueThat.myApi.unionDynamic(listPage).then((res) => {
            if (res.data.code === 200) {
              vueThat.hotList = res.data.data
            }
          })
          break
      }
    },
    // 公益项目和基金会切换
    welfareClick (type) {
      const vueThat = this
      const listPage = {
        union_id: vueThat.unionId,
        limit: 3,
        page: 1,
        nav_id: ''
      }
      vueThat.welfareNav = type
      if (type === '公益项目') {
        listPage.nav_id = 18
        vueThat.welfareNavId = 18
      } else {
        listPage.nav_id = 19
        vueThat.welfareNavId = 19
      }
      vueThat.myApi.totalList(listPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.welfareList = res.data.data
        }
      })
    },
    // 列表跳转
    listJump (navId) {
      this.$router.push({ path: '/forumList', query: { id: this.unionId } })
    },
    // 圈子跳转
    circleJump (rid) {
      const routeData = this.$router.resolve({
        path: '/cirlePostList/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 详情跳转
    allJump (type, listId, navId, isDoing) {
      this.mycommon.allJump(this, type, listId, navId, isDoing)
    },
    // 培训跳转
    trainJump (buy, index) {
      if (buy === 0 && this.trainList[index].price !== '0.00') {
        this.$alert('本视频为付费视频，请您下载APP，完成支付！', '温馨提示', {
          type: 'error',
          confirmButtonText: '下载APP',
          showClose: true
        }).then(() => {
          const routeData = this.$router.resolve({
            path: '/down'
          })
          window.open(routeData.href, '_blank')
        })
      } else {
        this.allJump(2, this.trainList[index].list_id, 14)
      }
    }
  }
}
</script>

<style scoped="scoped">
  .container_top_img{
    width: 100%;
    min-width: 1100px;
    height: auto;
    margin-top: -30px;
    margin-bottom: 30px;
  }
</style>
